// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"24639803","475":"3e9a2b1c","634":"19528be3","654":"ea27398d","663":"97240b5d","691":"100d5617","909":"84eb50b4"}[chunkId] + ".chunk.js";
};